/**
 * Cart page checkout — ensure checkout param is sent (do not disable submit button on submit).
 */
(function () {
  'use strict';

  function init() {
    var form = document.querySelector('form.cart-form');
    if (!form) return;
    if (form.querySelector('input[name="checkout"]')) return;
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'checkout';
    input.value = '';
    form.appendChild(input);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
